import {SmartComponent} from "smart-component-js";

class FormComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.init();
    }

    init() {
        const elementList = this.element.querySelectorAll('div[data-customvalue]');
        const elementDateList = this.element.querySelectorAll('div[data-type]');
        console.log("elementList", elementList);
        console.log("elementDateList", elementDateList);
        elementList.forEach((element) => {
            const valueCustom = element.getAttribute('data-customvalue');
            const inputElement = element.querySelector('input');
            inputElement.value = valueCustom;

        })
        elementDateList.forEach((element) => {
            const dateInputElement = element.querySelector('input');
            youserxp.utils.dateFillHelper(dateInputElement, 'DD/MM/YYYY');

        })
    }
}

export default FormComponent;